<template>
  <div class="section">
    <div v-if="isMaxScreen" class="page pc_page-3">
    <div class="page-3-content-container">
      <div class="step-top-text-container">{{ $t('components.section3.title') }}</div>
      <div class="step-image-conteiner">
        <div
          v-for="item in quickvaluationList"
          :key="item.id"
          :class="['setp-image-item', item.boxClass]"
          @click="handleClick(item)"
        >
          <div v-if="item.id !== 3" :class="['step-image-mengceng', item.mengcengClass]">
            <div :class="['step-name',`${isES ? 'es_' : 'en_'}item_${item.id}`]">{{ item.name }}</div>
          </div>
          <img :src="item.pcImage" alt="" class="step-image" />
        </div>
      </div>
      <div class="step-bottom-text-container">
        <div>{{ $t('components.section3.t1') }}</div>
        <div>{{ $t('components.section3.t2') }}</div>
      </div>
    </div>
    </div>

    <div v-else class="page page-3">
      <div class="step-top-text-container">{{ $t('components.section3.title') }}</div>
      <div class="step-image-conteiner">
        <div
          v-for="item in quickvaluationList"
          :key="item.id"
          :class="['setp-image-item', item.boxClass]"
          @click="handleClick(item)"
        >
          <div v-if="item.id !== 3"   :class="['step-name',`item_${item.id}`]">{{ item.name }}</div>
          <img :src="item.pcImage" alt="" class="step-image" />
        </div>
      </div>
      <div class="step-bottom-text-container">
        <div>{{ $t('components.section3.t1') }}</div>
        <div>{{ $t('components.section3.t2') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { isES } from '@/locales';
export default {
  name: 'section3',
  components: {},
  data() {
    return {
      isES,
      quickvaluationList: [
        {
          id: 1,
          type: 1,
          name: this.$t('components.section3.646tmse2fbo0'),
          boxClass: 'box-circle c-1',
          mengcengClass: 'mengceng-circle b-1',
          pcImage: require('../../../assets/image/eu-home/pic_1.png'),
          mbImage: require('../../../assets/image/eu-home/mb-step-4.png')
        },
        {
          id: 2,
          type: 2,
          name: this.$t('components.section3.section3-text2'),
          boxClass: 'box-square c-2',
          mengcengClass: 'mengceng-square b-2',
          pcImage: require('../../../assets/image/eu-home/pic_2.png'),
          mbImage: require('../../../assets/image/eu-home/mb-step-4.png')
        },
        {
          id: 3,
          type: 3,
          name: 'go trade-in',
          pcImage: require('../../../assets/image/eu-home/pic_3.png'),
          mbImage: require('../../../assets/image/eu-home/mb-step-4.png')
        },
        {
          id: 4,
          type: 4,
          name: this.$t('components.section3.section3-text4'),
          boxClass: 'box-square c-4',
          mengcengClass: 'mengceng-square b-4',
          pcImage: require('../../../assets/image/eu-home/pic_4.png'),
          mbImage: require('../../../assets/image/eu-home/mb-step-4.png')
        },
        {
          id: 5,
          type: 5,
          name: this.$t('components.section3.section3-text5'),
          boxClass: 'box-circle c-5',
          mengcengClass: 'mengceng-circle b-5',
          pcImage: require('../../../assets/image/eu-home/pic_5.png'),
          mbImage: require('../../../assets/image/eu-home/mb-step-4.png')
        }
      ]
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    })
  },
  methods: {

    handleClick(item){
      const { id } = item
      if([1,3].includes(id)){
        // 目前仅有手机类，其他不可跳转
        if(id === 1){
          // 跳到回收
          this.$router.push({ name: 'Product', params: { id } });
          return;
        }
        this.$router.push({ name: 'Product' });
      }else{
        this.$router.push({ name: 'Product' });
      }

    }
  }
};
</script>
<style scoped lang="less">
@media (min-width: 981px) {
  .section {
    .page {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .pc_page-3 {
      padding: 180px 0;
      .page-3-content-container{
        max-width: 1400px;
        margin: auto;
        .step-top-text-container {
          width: 100%;
          color: #252629;
          text-align: right;
          font-family: 'PingFang SC';
          font-size: 120px;
          font-weight: 500;
          line-height: 150%;
          padding-bottom: 40px;
        }
        .step-image-conteiner {     
          display: flex;
          flex-wrap: wrap;
          .setp-image-item {
            width: 280px;
            height: 280px;
            overflow: hidden;
            /* 使用弹性布局保证图片居中 */
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            position: relative;
            flex-shrink: 0;
            z-index: 99;
            &.box-circle {
              border-radius: 100%;
              &.c-1 {
                background: #5678ff;
              }
              &.c-5 {
                background: #ffb90f;
              }
            }
            &.box-square {
              border-radius: 14%;
              &.c-2 {
                background: #e184ef;
              }
              &.c-4 {
                background: #50c2df;
              }
            }
            .step-image-mengceng {
              width: 100%;
              height: 100%;
              position: absolute;
              flex-shrink: 0;
              z-index: 100;

              &.mengceng-circle {
                border-radius: 100%;
                &.b-1 {
                  transition: all .3s;
                  background: none;
                  &:hover {
                    background: linear-gradient(
                      180deg,
                      rgba(86, 120, 255, 0) 0%,
                      rgba(86, 120, 255, 0.9) 86.34%
                    );
                  }
                }
                &.b-5 {
                  transition: all .3s;
                  background: none;
                  &:hover {
                    background: linear-gradient(
                      180deg,
                      rgba(255, 185, 15, 0) -19.23%,
                      rgba(255, 185, 15, 0.9) 86.34%
                    );
                  }
                }


                .step-name {
                  position: absolute;
                  top: 24px;
                  color: #fff;
                  font-family: 'PingFang SC';
                  font-size: 24px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 150%; /* 36px */
                  transition: all .3s;
                  z-index: 101;
                  &.es_item_1{
                    left: 35%;
                  }
                  &.es_item_5{
                    left: 25%;
                  }
                  &.en_item_1{
                    left: 24%;
                  }
                  &.en_item_5{
                    left: 27%;
                  }
                }
                &:hover {
                  .step-name {
                    font-size: 36px;
                    top: 42%;
                    &.es_item_1{
                      left: 30%;
                    }
                    &.es_item_5{
                      left: 9%;
                    }
                    &.en_item_1{
                      left: 10%;
                    }
                    &.en_item_5{
                      left: 19%;
                    }
                  }
                }
              }
              &.mengceng-square {
                border-radius: 14%;
                &.b-2 {
                  transition: all .3s;
                  background: none;
                  &:hover {
                    background: linear-gradient(
                      180deg,
                      rgba(225, 132, 239, 0) 0%,
                      rgba(225, 132, 239, 0.9) 86.34%
                    );
                  }
                }
                &.b-4 {
                  transition: all .3s;
                  background: none;
                  &:hover {
                    background: linear-gradient(
                      180deg,
                      rgba(80, 194, 223, 0) -19.23%,
                      rgba(80, 194, 223, 0.9) 86.34%
                    );
                  }
                }

                .step-name {
                  position: absolute;
                  top: 24px;
                  left: 34px;
                  color: #fff;
                  font-family: 'PingFang SC';
                  font-size: 24px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 150%; /* 36px */
                  transition: all .3s;
                  z-index: 101;
                }
                &:hover {
                  .step-name {
                    font-size: 36px;
                    top: 38%;

                    &.es_item_2, &.es_item_4{
                      left: 9%;
                    }
                    &.en_item_2, &.en_item_4{
                      left: 17%;
                    }
                  }
                }
              }
            }
            .step-image {
              /* 设置大小 */
              width: 100%;
              height: 100%;
              /* 给图片添加过渡效果 */
              transition: all .3s;
            }
            &:not(:nth-child(3)):hover {
              img {
                /* 鼠标悬停放大 */
                width: 120%;
                height: 120%;
              }
            }
          }
        }
        .step-bottom-text-container{
          // width: calc(100% - 520px);
          width: 100%;
          color: #8F949D;
          font-family: "PingFang SC";
          font-size: 28px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%; /* 42px */
          margin-top: 40px;
        }
      }
    }
  }
}
@media (max-width: 980px) {
  .section {
    .page {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .page-3 {
      width: calc(100% - 60px);
      padding: 120px 30px;
      .step-top-text-container {
        width: 100%;
        color: #252629;
        text-align: right;
        font-family: 'PingFang SC';
        font-size: 112px;
        font-style: normal;
        font-weight: 500;
        line-height: 100%; /* 180px */
        margin-bottom: 72px;
      }
      .step-image-conteiner {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .setp-image-item {
          width: 33.33%;
          height: 100%;
          overflow: hidden;
          /* 使用弹性布局保证图片居中 */
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          position: relative;
          flex-shrink: 0;
          z-index: 99;
          &.box-circle {
            border-radius: 100%;
            &.c-1 {
              background: #5678ff;
            }
            &.c-5 {
              background: #ffb90f;
            }

            .step-name {
              position: absolute;
              top: 20px;
              color: #fff;
              font-family: 'PingFang SC';
              font-size: 20px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%; /* 36px */
              transition: all .3s;
              z-index: 101;
              &.es_item_1{
                left: 35%;
              }
              &.es_item_5{
                left: 20%;
              }
              &.en_item_1{
                left: 25%;
              }
              &.en_item_5{
                left: 20%;
              }
            }
          }
          &.box-square {
            border-radius: 10%;
            &.c-2 {
              background: #e184ef;
            }
            &.c-4 {
              background: #50c2df;
            }
            .step-name {
              position: absolute;
              top: 20px;
              left: 30px;
              color: #fff;
              font-family: 'PingFang SC';
              font-size: 20px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%; /* 36px */
              transition: all .3s;
              z-index: 101;
            }
          }
          .step-image {
            width: 100%;
            height: 100%;
          }
        }
      }
      .step-bottom-text-container{
        color: #8F949D;
        font-family: "PingFang SC";
        font-size: 28px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 42px */
        margin-top: 40px;
      }
    }
  }
}
</style>
